"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomEqualSet = void 0;

var CustomEqualSet = /*#__PURE__*/function () {
  function CustomEqualSet(isEqual) {
    _classCallCheck(this, CustomEqualSet);

    this.isEqual = isEqual;
    this.data = [];
  }

  _createClass(CustomEqualSet, [{
    key: "tryAdd",
    value: function tryAdd(value) {
      for (var idx = 0; idx !== this.data.length; ++idx) {
        if (this.isEqual(this.data[idx], value)) {
          return false;
        }
      }

      this.data.push(value);
      return true;
    }
  }, {
    key: "size",
    value: function size() {
      return this.data.length;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data.slice();
    }
  }]);

  return CustomEqualSet;
}();

exports.CustomEqualSet = CustomEqualSet;